<template>
  <v-radio
    class="bm-radio"
    v-bind="$attrs"
    :value="value"
    :label="labelVal"
    :data-qa="dataQaVal"
    @change="handleChange($event)"
  ></v-radio>
</template>

<script lang="ts">
export default {
  name: "BmRadio",
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { useBmLabelled } from "@/components/controls/input/mixins/BmLabelled";
import type Key from "@/app/types/common/key";

interface BmRadioProps {
  label?: string | null;
  tooltip?: string | null;
  t?: Key;
  dataQa?: object | string;
  value?: any;
}

interface BmRadioEvents {
  (event: "update:value", value: any): void;
}

const props = withDefaults(defineProps<BmRadioProps>(), {
  label: null,
  tooltip: null,
});

const emit = defineEmits<BmRadioEvents>();

const { labelVal, dataQaVal } = useBmLabelled(() => props);

const handleChange = (evt: any) => {
  emit("update:value", evt);
};
</script>

<style scoped lang="sass">
@import "src/sass/typography"

.bm-radio :deep(label.v-label)
  @include bm-body

.bm-radio.v-radio--is-disabled :deep(label.v-label)
  color: rgba(#000000, .38)!important
</style>
